<template>
    <div class="w-full p-4 bg-[#F0F0F0] column_start_start">
        <div class="row_center_start w-full flex-wrap mb-2">
            <text class="font-base font-semibold text-[#666666] mr-3">店家外送日期</text>
            <text class="font-base">{{ deliveryDate }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap mb-2">
            <text class="font-base font-semibold text-[#666666] mr-3">店家外送時間</text>
            <text class="font-base">{{ deliveryTime }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap mb-2">
            <text class="font-base font-semibold text-[#666666] mr-3">送餐地址</text>
            <text class="font-base">{{ deliveryAddress }}</text>
        </div>
        <div class="row_center_start w-full flex-wrap">
            <text class="font-base font-semibold text-[#666666] mr-3">聯絡電話</text>
            <text class="font-base">{{ deliveryPhone }}</text>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        getPayment() {
            return this.$store.state.cart.payment
        },
        deliveryDate() {
            return this.getPayment.pickupDate
        },
        deliveryTime() {
            return this.getPayment.pickupTime
        },
        deliveryAddress() {
            return this.getPayment.address
        },
        deliveryPhone() {
            return this.getPayment.phone
        }
    }
}
</script>
<style lang="">

</style>